module.exports = __webpack_public_path__ + "media/quest-click.d5d006a4.mp3";